import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Modal } from 'syngenta-react-components'
import DetailView from '../../../dpe-usco/components/Details/DetailView'
import DocUploader from './DocUploader'
import '../../../scss/config/_variables.scss'
import { saveAccountLeads } from '../../../services/apiHelper'
import { FailedAssignmentModal, LoadingModal, ServerErrorModal, SuccessModal } from './Models'

const CancelModal = ({ showCancelModal, setCancelModal }) => {
  let history = useHistory()
  return (
    <Modal
      autoHeight
      show={showCancelModal}
      handleClose={() => setCancelModal(false)}
    >
      <div className='w100% tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
        <div className='bb1-s-lightgray df jcsb'>
          <div className='df ml15 mt15 mb15'>
            <div className='fw600 ml10'>
              Leave upload account leads?
            </div>
          </div>
        </div>
        <div className='p25 h80 df aic jcfs'>
          Unsaved account leads will not be saved on leaving.
        </div>
        <div className='bt1-s-lightgray df aic jcfe'>
          <div className='mt8 mb8 mr8'>
            <Button customClassName='mr8 miw75 pl1 pr1' text='Close' onClick={() => setCancelModal(false)} />
            <Button customClassName='miw70' type='error' text='Leave upload' onClick={() => history.goBack()} />
          </div>
        </div>
      </div>
    </Modal>
  )
}


export const UploadAccountLeads = () => {
  const [hasUpload, setHasUpload] = useState(false)
  const [hasAllRequiredData, setHasAllRequiredData] = useState(false)
  const [showCancelModal, setCancelModal] = useState(false)
  const [isVerified, setVerified] = useState(false)
  const [uploadedData, setUploadedData] = useState([])
  const [isLoading, setIsLoading] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [failedAssignments, setFailedAssignments] = useState([])
  const [tableData, setTableData] = useState()

  const uploadFiles = () => {
    const filteredData = uploadedData.map(curr => {
      return {
        reseller_sap_id: curr.reseller_sap_id,
        new_account_lead_email: curr.new_account_lead_email
      }
    })
    const payload = {
      'assignment_list': [
        ...filteredData
      ]
    }

    saveAccountLeads(payload)
      .then(res => {
        if (res.failuer_assignments.length > 0) {
          setFailedAssignments(res.failuer_assignments)
          setIsLoading('error')
          clear()
        } else if (res[0].success === false) {
          setIsLoading('server error')
        } else {
          setIsLoading('success')
          clear()
        }
      })

  }
  const postAccountLeads = () => {
    setShowModal(true)
    setIsLoading('loading')
    setTimeout(uploadFiles, 3000)
  }

  const clear = () => {
    setUploadedData([])
    setHasUpload(false)
    setVerified(false)
    setTableData()
  }
  const buttons = (
    <div className='df'>
      <div className='mr10'>
        <Button text='Cancel' clickHandler={() => setCancelModal(true)}></Button>
      </div>
      <div className='mr10'>
        <Button text='Verify' backgroundColor={hasUpload ? '#238661' : '#8FC0AE'} textColor={'#FFFFFF'} disabled={!hasUpload || !hasAllRequiredData} clickHandler={() => setVerified(true)}></Button>
      </div>
      <div>
        <Button text='Save' backgroundColor={isVerified ? '#238661' : '#8FC0AE'} textColor={'#FFFFFF'} disabled={!isVerified} clickHandler={postAccountLeads}></Button>
      </div>
    </div>
  )


  return (
    <>
      <CancelModal showCancelModal={showCancelModal} setCancelModal={setCancelModal} />

      {/* <button
        className='df aic jcsb posf l20'
        style={{
          background: 'none',
          color: 'inherit',
          border: 'none',
          padding: 0,
          font: 'inherit',
          cursor: 'pointer',
          outline: 'inherit'
        }}
        onClick={() => setCancelModal(true)}>
        <img src={leftArrow} alt='return arrow' className='curp mr10' />
        <span className='fz17 c-neutral-500 fs'>Back</span>
      </button> */}

      <DetailView button={buttons} title='Upload Account Leads' disableBack={true}>
        <>
          <DocUploader
            hasUpload={hasUpload}
            setHasUpload={setHasUpload}
            setHasAllRequiredData={setHasAllRequiredData}
            isVerified={isVerified}
            setVerified={val => setVerified(val)}
            postAccountLeads={postAccountLeads}
            uploadedData={uploadedData}
            tableData={tableData}
            setTableData={data => setTableData(data)}
            setUploadedData={data => setUploadedData(data)}
          />
        </>
      </DetailView>

      <Modal
        autoHeight
        show={showModal}
        handleClose={() => setShowModal(false)}
      >
        <>
          {(isLoading === 'loading' || isLoading === 'loader') && <LoadingModal showModal={isLoading} />}
          {isLoading === 'error' &&
            <FailedAssignmentModal
              showModal={showModal}
              setShowModal={setShowModal}
              assignments={failedAssignments}
            />
          }
          {isLoading === 'server error' &&
            <ServerErrorModal
              showModal={showModal}
              setShowModal={setShowModal}
            />
          }
          {isLoading === 'success' &&
            <SuccessModal
              showModal={showModal}
              setShowModal={setShowModal}
              text='Account leads successfully saved'
            />
          }
        </>
      </Modal>
    </>
  )
}

export default UploadAccountLeads
